import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";
import { Cookies } from "react-cookie";

export const presidentUpdate = createAsyncThunk(
  "presidentUpdate",
  async (data) => {
    try {
      const cookies = new Cookies();
      const token = cookies.get("token");
      const response = await AxiosInstance.post(
        `${API_KEY}/api/president/update/${
          data.presidentid ? data.presidentid : ""
        }`,
        data.presidentInfo,
        {
          headers: { Authorization: `Barear ${token}` },
          "Content-Type": "application/json",
        }
      );

      return response;
    } catch (error) {
      if (error.response) {
        throw error.response.data.message;
      } else {
        throw error;
      }
    }
  }
);

const initialState = {
  isLoading: false,
  presidentUpdateData: null,
  isError: false,
  errorMessage: "",
};
const presidentUpdateSlice = createSlice({
  name: "presidentUpdate",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(presidentUpdate.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(presidentUpdate.fulfilled, (state, action) => {
      state.isLoading = false;
      state.presidentUpdateData = action.payload;
    });
    builder.addCase(presidentUpdate.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default presidentUpdateSlice.reducer;
